import label from './pie.data.label'
import labelLine from './pie.data.labelLine'
import itemStyle from './pie.data.itemStyle'
import emphasis from './pie.data.emphasis'
import tooltip from './pie.data.tooltip'

export default {
  name: "data",
  nickname: "数据",
  desc: "系列中的数据内容数组。数组项可以为单个数值，如：",
  type: "array",
  props: {
    name: {
      name: "name",
      nickname: "名称",
      desc: "数据项名称。",
    },
    value: {
      name: "value",
      nickname: "值",
      desc: "数据值。",
      type: "pureValue",
    },
    selected: {
      name: "selected",
      nickname: "选中状态",
      desc: "该数据项是否被选中。",
      value: false,
      defaultValue: false,
    },
    label,
    labelLine,
    itemStyle,
    emphasis,
    tooltip,
  },
}
